import {
  AppleImage,
  EarPhoneImage,
  GoogleImage,
  HeadPhoneImage,
  FidgetImage,
  IOSImage,
  MiniBotImage,
  MosquitoImage
 } from '../image';

export const bestSellerProductDetails = [
  {
    name: 'Mouse',
    image: AppleImage
  },
  {
    name: 'Earphone',
    image: EarPhoneImage
  },
  {
    name: 'Google',
    image: GoogleImage
  },
  {
    name: 'Headphone',
    image: HeadPhoneImage
  },
  {
    name: 'Fidget',
    image: FidgetImage
  },
  {
    name: 'Mobile',
    image: IOSImage
  },
  {
    name: 'Minibot',
    image: MiniBotImage
  },
  {
    name: 'Mosquito',
    image: MosquitoImage
  },
]